import { format as setFormat, addDays, addWeeks, addMonths, addYears } from 'date-fns';
import { AddTimeFunction, AddTimeToDateOptions, DateOutput } from './type';

const addTimeToDate = (
  amountToAdd: number,
  addTimeFunction: AddTimeFunction,
  { date = new Date(), format = 'date' }: AddTimeToDateOptions = {},
): DateOutput => {
  const newDate = addTimeFunction(date, amountToAdd);
  return format === 'date' ? newDate : setFormat(newDate, format);
};

export const addDaysToDate = (daysToAdd: number, options: AddTimeToDateOptions = {}): DateOutput =>
  addTimeToDate(daysToAdd, addDays, options);

export const addMonthsToDate = (
  monthsToAdd: number,
  options: AddTimeToDateOptions = {},
): DateOutput => addTimeToDate(monthsToAdd, addMonths, options);

export const addWeeksToDate = (
  weeksToAdd: number,
  options: AddTimeToDateOptions = {},
): DateOutput => addTimeToDate(weeksToAdd, addWeeks, options);

export const addYearsToDate = (
  yearsToAdd: number,
  options: AddTimeToDateOptions = {},
): DateOutput => addTimeToDate(yearsToAdd, addYears, options);
